// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"collection_routeHeader_B98fF","addButton":"collection_addButton_2va2f"};